import React from "react";
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import "./App.css";
import Footer from "./components/Footer";
import 'antd/dist/antd.css';

import Header from "./components/Header";
import LandingPage from "./pages/LandingPage";
import SignUpPage from "./pages/SignUpPage";
import SuccessPage from "./pages/SuccessPage";
import { Test } from "./pages/test";

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route 
            exact
            path="/"
          >
              <LandingPage />
          </Route>
          <Route 
          path="/opt-out">
            <SignUpPage />
          </Route>
          <Route 
          path={"/test"}
          component={Test}
          />
          <Route 
            path="/welcome"
            component={SuccessPage}
          />
        </Switch>
      </Router>
     
    </div>
  );
}

export default App;
